export const FINTECH_META_DESCRIPTION_BG =
  "Медиен мониторинг и медийни анализи за финтех компании в Югоизточна Европа - регулаторни сигнали, доверие, конкуренти и анализ на репутацията.";
